import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';

/**
 * One headline figure: a sentence-case label, the value, and an optional detail
 * line. Deliberately plain — no accent colour, no icon tile, no gradient — so a
 * row of these reads as figures rather than as decoration.
 *
 * The value is whatever the caller renders (a `<Money>`, a count, an em dash);
 * this component formats nothing, so it cannot round or compact a figure the
 * caller meant to show exactly.
 */
export function StatTile({
  label,
  value,
  detail,
  className,
}: {
  label: ReactNode;
  value: ReactNode;
  detail?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cx('min-w-0 rounded-md border border-border bg-surface px-4 py-3', className)}>
      <div className="text-xs text-fg-muted">{label}</div>
      <div className="mt-1 text-2xl font-semibold text-fg tabular-nums">{value}</div>
      {detail !== undefined && detail !== null && detail !== false && (
        <div className="mt-1 text-xs text-fg-muted">{detail}</div>
      )}
    </div>
  );
}
